// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-input-style {
  width: 100%;
  padding-bottom: 20px !important;
  margin-bottom: 30px;
  background-color: white;
}

.autocomplete-wrapper {
  width: "100%" !important;
  margin-bottom: "30px";
  background-color: "white";
  border: "1px solid gray";
  border-radius: "6px";
}

.MuiInputBase-root {
  background-color: "red" !important;
}`, "",{"version":3,"sources":["webpack://./src/components/tags/DescriptionSelector.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,wBAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,kCAAA;AACJ","sourcesContent":[".custom-input-style{\n    width:100%;\n    padding-bottom: 20px!important; \n    margin-bottom:30px;\n    background-color: white;;\n}\n\n.autocomplete-wrapper{\n    width: '100%'!important;\n    margin-bottom:'30px';\n    background-color:'white';\n    border:'1px solid gray'; \n    border-radius:'6px' ;\n}\n\n.MuiInputBase-root{\n    background-color:'red'!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
